import styled from 'styled-components';

export const ButtonPanel = styled.div`
  margin-bottom: 20px;
  display: flex;

  & > * {
    margin-right: 10px;
  }

  .align-right {
    margin: 0 0 0 auto;
  }

  .end-buttons {
    .btn {
      margin-left: 10px;
    }
  }

  @media (max-width: 600px) {
    flex-direction: column;

    & > * {
      margin: 0 0 10px;
    }

    .btn {
      width: 100%;
    }

    .end-buttons {
      margin: 0;

      .btn {
        margin: 0;
      }
    }
  }
`;

export const ManagerList = styled.ul`
  .delete-manager {
    margin-left: 5px;
    cursor: pointer;
    transition: 0.3s all;
    -webkit-appearance: none;
    border: 0;
    outline: 0;

    &:hover {
      color: #cc6464;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/EventDetail/styles.js